import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';

@Component({
  selector: 'app-delivery-quantity',
  templateUrl: './delivery-quantity.component.html',
  styleUrls: ['./delivery-quantity.component.scss'],
  standalone: false
})
export class DeliveryQuantityComponent implements OnInit {
  quantity: any;
  amount: any;
  @Input() unit: any;
  @Input() price: any;
  showMore = false;
  rate = 10;
  @Input() moq: any;
  availableQuantityGm = [0.005, 0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 0.75];
  availableQuantityKg = [1, 1.5, 2];
  availableQuantityPlt = [0.25, 0.5, 1, 1.5, 2, 4, 5, 6, 8, 10, 12];
  availableQuantityMl = [0.05, 0.1, 0.2, 0.25, 0.36, 0.5, 0.65, 0.75];
  availableQuantityLtr = [1, 1.5, 2];
  availableQuantityGls = [1, 2, 4, 6, 8, 10, 12, 14, 16, 20, 24];
  availableQuantityPkt = [1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20];
  availableQuantityPcs = [0.5, 1, 1.5, 2, 4, 5, 6, 8, 10, 12, 15];

  constructor(
    private modalCtrl: ModalController,
    private commonservice: CommonService
  ) { }

  ngOnInit() { }

  closeModal() {
    const quantity = this.amount ? this.unit == 'Pcs' ? Math.round(this.amount / this.price) : (this.amount / this.price).toFixed(3) : this.unit == 'Pcs' ? Math.round(this.quantity) : this.unit == 'Plt' ? this.quantity : this.quantity.toFixed(3);
    console.log(quantity);
    this.modalCtrl.dismiss({ quantity }, 'confirm');
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }

  toggleMore() {
    this.showMore = !this.showMore;
  }

  setQuanity(val: any, unt: any) {
    this.quantity = val;
    const myVal = parseFloat(this.amount ? this.unit == 'Pcs' ? (this.amount / this.price) : (this.amount / this.price).toFixed(3) : this.unit == 'Pcs' ? (this.quantity) : this.unit == 'Plt' ? this.quantity : this.quantity.toFixed(3));
    if (this.moq && (parseFloat(this.moq) > myVal)) {
      const minOrder = this.commonservice.getTranslatedMessage("Min order") || "Min order";
      const selectQuntity = this.commonservice.getTranslatedMessage("please select qty min") || "please select qty min";
      const unit = this.commonservice.getTranslatedMessage(this.unit) || this.unit;
      this.commonservice.danger(minOrder + ' ' + this.moq + ' ' + unit + ' ' + "," + ' ' + selectQuntity + ' ' + this.moq + ' ' + unit);
    } else {
      if (parseFloat(this.amount ? this.unit == 'Pcs' ? Math.round(this.amount / this.price) : (this.amount / this.price).toFixed(3) : this.unit == 'Pcs' ? Math.round(this.quantity) : this.unit == 'Plt' ? this.quantity : this.quantity.toFixed(3)) < 0) {
        this.commonservice.danger("Quantity can not be negative");
      } else {
        this.showMore = false;
        this.unit = unt;
        this.closeModal();
      }
    }
  }

  decimalQuantityValue() {
    this.quantity = parseFloat(this.quantity.toFixed(2))
  }
}
